export interface IConfig {
  messagingScriptUrl: string;
  scrt2Url: string;
  orgId: string;
  messagingName: string;
  messagingUrl: string;
}

export class SettingService {
  messagingScriptUrl: string;
  scrt2Url: string;
  orgId: string;
  messagingName: string;
  messagingUrl: string;

  loadConfig(config: IConfig) {
    this.messagingScriptUrl = config.messagingScriptUrl;
    this.scrt2Url = config.scrt2Url;
    this.orgId = config.orgId;
    this.messagingName = config.messagingName;
    this.messagingUrl = config.messagingUrl;
  }
}
